/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiV0ConstructiondayreportDeleteConstructionDayReportPost$Params {
  reportId?: string;
}

export function apiV0ConstructiondayreportDeleteConstructionDayReportPost(http: HttpClient, rootUrl: string, params?: ApiV0ConstructiondayreportDeleteConstructionDayReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructiondayreportDeleteConstructionDayReportPost.PATH, 'post');
  if (params) {
    rb.query('reportId', params.reportId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV0ConstructiondayreportDeleteConstructionDayReportPost.PATH = '/api/v0/constructiondayreport/deleteConstructionDayReport';
